import styled from "@emotion/styled";
import { css } from "@emotion/react";
import DatePicker from "react-widgets/DatePicker";
import Localization from "react-widgets/Localization";
import { DateLocalizer } from "react-widgets/IntlLocalizer";

const chakraVar = (element, value) => `var(--chakra-${element}-${value})`;

const dynamicStyle = ({ size, colorscheme }) =>
	css`
		.rw-widget-picker {
			box-shadow: none;
			color: ${chakraVar(`colors`, `gray-200`)};
			border: 1px solid ${chakraVar(`colors`, `gray-200`)};
			height: ${chakraVar(`sizes`, `10`)};
			border-radius: ${chakraVar(`radii`, size)};
			transition-property: ${chakraVar(`transition-property`, `common`)};
			transition-duration: ${chakraVar(`transition-duration`, `normal`)};

			:focus-within {
				box-shadow: 0 0 0 1px;
				color: ${chakraVar(`colors`, `${colorscheme}-400`)};
				border: 1px solid ${chakraVar(`colors`, `${colorscheme}-400`)};
			}
		}

		.rw-widget-input {
			width: inherit;
			font-size: ${chakraVar(`fontSizes`, size)};
			padding: 0 1rem;
			box-shadow: none;
			::placeholder {
				color: ${chakraVar(`colors`, `gray-400`)};
			}
		}
		input[type="text"]:disabled {
			background: white;
		}
		.rw-input-addon,
		.rw-input-addon.rw-picker-btn {
			border-color: ${chakraVar(`colors`, `gray-200`)};
		}
		.rw-cell.rw-state-selected {
			background: ${chakraVar(`colors`, `${colorscheme}-500`)};
			border-color: ${chakraVar(`colors`, `${colorscheme}-500`)};
		}
		.rw-calendar-header {
			padding: ${chakraVar(`space`, 1)} ${chakraVar(`space`, 2)};
		}
		.rw-calendar-transition-group {
			font-size: ${chakraVar(`fontSizes`, size)};
		}
	`;

const StyledDatePicker = styled(DatePicker)`
	${dynamicStyle};
`;

const defaultCulture = {
	label: "English: Great Britain",
	culture: "en-gb",
	firstOfWeek: 1,
};

export default function ReactDatePicker({ size = "md", colorscheme = "brand", ...props }) {
	return (
		<Localization date={new DateLocalizer(defaultCulture)}>
			<StyledDatePicker size={size} colorscheme={colorscheme} {...props} />
		</Localization>
	);
}
